import { useContext, useEffect } from "react";
import { TableContext, TeamContext } from "../context";
import { Phase } from "../util/enums";

const useHandsState = (isTheUserDilemaOwner: boolean): [] => {
    const { game } = useContext(TeamContext);
    const { setAreAnimatedHandsShown } = useContext(TableContext);


    useEffect(() => {
        if (game?.phase !== Phase.QUESTION_CARD )
            setAreAnimatedHandsShown(true);

        if (game?.phase === Phase.QUESTION_CARD && isTheUserDilemaOwner)
            setAreAnimatedHandsShown(false);

        if (game?.phase === Phase.QUESTION_CARD && !isTheUserDilemaOwner)
            setAreAnimatedHandsShown(true);

        if (game?.phase === Phase.ACTION_CARD)
            setAreAnimatedHandsShown(false);

    }, [game?.phase, isTheUserDilemaOwner, setAreAnimatedHandsShown]);

    return [];
}

export default useHandsState;